import { render, staticRenderFns } from "./HowToAstraNew.vue?vue&type=template&id=6a227abc&"
import script from "./HowToAstraNew.vue?vue&type=script&lang=js&"
export * from "./HowToAstraNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports